<template>
    <div class="flex justify-between">
        <BlackButton style="width:46%">{{black}}</BlackButton>
        <TooliabaButton style="width:46%">{{yellow}}</TooliabaButton>
    </div>
</template>

<script>
import BlackButton from '@/components/buttons/BlackButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    props: {
        black: {
            type: String,
            required: true
        },
        yellow: {
            type: String,
            required: true
        }
    },
    components: {
        BlackButton,
        TooliabaButton
    }
};
</script>
